import { createSlice } from "@reduxjs/toolkit";

const googlePopupSlice = createSlice({
  name: "googlePopup",
  initialState: {
    isGooglePopupOpen: false,
  },
  reducers: {
    openGooglePopup: (state) => {
      state.isGooglePopupOpen = true;
    },
    closeGooglePopup: (state) => {
      state.isGooglePopupOpen = false;
    },
    setGooglePopup: (state, action) => {
      state.isGooglePopupOpen = action.payload;
    },
  },
});

export const {
  openGooglePopup,
  closeGooglePopup,
  setGooglePopup,
} = googlePopupSlice.actions;

export default googlePopupSlice;
